/**
 * Pre-compiled localized messages for Toast component
 *
 * Generated by scripts/generate-dictionaries.ts
 * DO NOT EDIT MANUALLY
 *
 * @see https://react-spectrum.adobe.com/react-aria/internationalization.html
 */

import {
  type LocalizedString,
  type LocalizedStrings,
} from "@internationalized/string";
import { normalizeMessages } from "../../utils/normalize-messages";

// Pre-compiled message functions
import toastMessages_en from "./intl/en";
import toastMessages_de from "./intl/de";
import toastMessages_es from "./intl/es";
import toastMessages_fr from "./intl/fr-FR";
import toastMessages_pt from "./intl/pt-BR";

// Raw LocalizedStrings object for use with useLocalizedStringFormatter hook
export const toastMessagesStrings: LocalizedStrings<string, LocalizedString> = {
  en: normalizeMessages(toastMessages_en),
  de: normalizeMessages(toastMessages_de),
  es: normalizeMessages(toastMessages_es),
  "fr-FR": normalizeMessages(toastMessages_fr),
  "pt-BR": normalizeMessages(toastMessages_pt),
} as LocalizedStrings<string, LocalizedString>;

/**
 * Available message keys for Toast component
 */
export type ToastMessageKey = "dismiss";
